import { useLocalStorage } from '@mantine/hooks';
import { useMe, useTrackingEvent } from '@vrplatform/data';
import { useCallback } from 'react';

// Per user and browser, like the ChatVRT toggle. The team-wide setting
// `showVRPilotGuide` stays the switch for everyone.
export function useVRPilotGuideVisibility() {
  const { id: userId } = useMe();
  const track = useTrackingEvent();
  const [hidden, setHidden] = useLocalStorage<boolean>({
    key: `vrpilot-guide.hidden.${userId}`,
    defaultValue: false,
    getInitialValueInEffect: false,
  });
  const toggleHidden = useCallback(() => {
    void track('vrpilot_guide_visibility_changed', { visible: hidden });
    setHidden(!hidden);
  }, [hidden, setHidden, track]);

  return { hidden, toggleHidden };
}
